import { initializeApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import "regenerator-runtime/runtime";
import {
  getAuth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as signOutUser,
  sendPasswordResetEmail,
  confirmPasswordReset,
  verifyPasswordResetCode,
  sendEmailVerification,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD7NhAXzpxKEiUqEsF-0ig0xVhcyiFDuCg",
  authDomain: "imaginethepossibilies.firebaseapp.com",
  projectId: "imaginethepossibilies",
  storageBucket: "imaginethepossibilies.appspot.com",
  messagingSenderId: "782394346545",
  appId: "1:782394346545:web:1b4ecf2506e0996f0d5910",
  measurementId: "G-130KYFSN2G",
};

// const userKey = "user";
let isInitialized = false;

const fbapp = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
const fbAuth = getAuth(fbapp);

// Hoping this initializes the analytics
const analytics = getAnalytics(fbapp);

let authInitialized = false;

////////////////////////////////////////////////////////
// emits firebase-user-changed event
////////////////////////////////////////////////////////
const useAuth = () => {
  if (!isInitialized) {
    // set(userKey, null);

    // Listen to firebase auth state changes
    /////////////////////////////////
    // This may be of little help since it gets called
    // on each page load. Could however set isInitialized
    // in session storage and check that on each page load?
    /////////////////////////////////
    onAuthStateChanged(fbAuth, (retUser) => {
      const user = retUser;

      const UserSignInEvent = new CustomEvent("firebase-user-changed", {
        detail: { user },
      });
      window.dispatchEvent(UserSignInEvent);
      authInitialized = true;
      // set(userKey, JSON.stringify(user));
      if (user) {
        console.log(`User signed in: ${user?.email}`);
      } else {
        console.log("User signed out");
        //   if (router.app.$route.meta.authRequired) router.push({ name: "login" });
      }
    });

    isInitialized = true;
  }

  const ready = () => {
    return new Promise((resolve, reject) => {
      const unsubscribe = onAuthStateChanged(
        fbAuth,
        (user) => {
          unsubscribe();
          resolve(user);
        },
        reject
      );
    });
  };

  const getIdToken = async () => {
    try {
      const token = await fbAuth.currentUser.getIdToken();
      if (!token) throw new Error("Called getIdToken on invalid user");
      return token;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getCurrentUser = () => {
    const user = fbAuth.currentUser;
    return user;
  };

  const getUID = () => {
    try {
      const uid = fbAuth.currentUser.uid;
      if (!uid) throw new Error("Called getUID on invalid user");
      return uid;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const createUser = async (userData) => {
    try {
      const data = await createUserWithEmailAndPassword(
        fbAuth,
        userData?.email,
        userData?.password
      );
      console.log("User created");
      console.log("data: ", data);
      return data?.user;
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(`Error signing in: ${errorCode} ${errorMessage}`);
      return { error: error.message };
    }
  };

  const signIn = async (userData) => {
    try {
      const data = await signInWithEmailAndPassword(
        fbAuth,
        userData?.email,
        userData?.password
      );
      return data?.user;
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(`Error signing in: ${errorCode} ${errorMessage}`);
      return { error: error.message };
    }
  };

  const signOut = async () => {
    try {
      await signOutUser(fbAuth);
      return true;
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(`Error signing in: ${errorCode} ${errorMessage}`);
      return false;
    }
  };

  const sendPWResetEmail = async (email = "") => {
    try {
      await sendPasswordResetEmail(fbAuth, email);
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(
        `Error sending password reset email: ${errorCode} ${errorMessage}`
      );
      return { error: error.message };
    }
  };

  const confirmPWReset = async (userData) => {
    try {
      await confirmPasswordReset(fbAuth, userData?.code, userData?.newPassword);
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(
        `Error confirming password reset: ${errorCode} ${errorMessage}`
      );
      return { error: error.message };
    }
  };

  const verifyPWResetCode = async (code) => {
    try {
      await verifyPasswordResetCode(fbAuth, code);
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(
        `Error verifying password reset code: ${errorCode} ${errorMessage}`
      );
    }
  };

  const sendEmailVerifyLink = async () => {
    const user = getCurrentUser();
    if (!user) {
      throw new Error("No user provided to send email verification link");
    }

    try {
      await sendEmailVerification(user);
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(
        `Error sending email verification: ${errorCode} ${errorMessage}`
      );
    }
  };

  return {
    createUser,
    signIn,
    signOut,
    sendPWResetEmail,
    confirmPWReset,
    verifyPWResetCode,
    sendEmailVerifyLink,
    getCurrentUser,
    getIdToken,
    getUID,
    ready,
  };
};

console.log("firebase.boot");

export default useAuth;
